import React from 'react';
import { I18n, Config, windowPopUp } from '@deporvillage/utils-library-component';
import Picture from '@deporvillage/picture-component';

import styles from './SocialRegister.module.scss';

const SocailRegister = () => {

    const { url } = React.useContext(Config);

    // istanbul ignore next
    const handleSocialLoginPopUp = (e) => {
        e.preventDefault();
        const ref = windowPopUp(`/customer/social/google/sign-in`, '700', '500');
        const timer = setInterval(() => {
            if(ref.closed) {
                clearInterval(timer);
                window.location.reload();
            }
        }, 200);
    };

    return (
        <div className={styles['social-register-wrapper']}>
            <p className={styles['title-social']}>
                <I18n>register.register_popup.title.social</I18n>
            </p>
            <button
                className={styles['google-social-button']}
                data-testid='google-social-button'
                onClick={handleSocialLoginPopUp}
            >
                <span className={styles['google-social-button-logo']}>
                    <Picture
                        src={'/static/icons/icon_google.png'}
                        height={25}
                        width={25}
                        transparent
                    />
                </span>{' '}
                <span className={styles['google-social-button-text']}>
                    <I18n>register.register_popup.title.google_login</I18n>
                </span>
            </button>
        </div>
    );
}

export default SocailRegister;
